<template>
  <BaseModalSmall
    testId="publish-location"
    @close="$emit('close')"
  >
    <BaseText size="l">
      {{ $t('feedback.publication.confirmation_modal.title') }}
    </BaseText>
    <template #center>
      <BaseText>
        {{ $t('feedback.publication.confirmation_modal.disclaimer') }}
      </BaseText>
      <BaseAlert
        color="warning"
        :text="$t('feedback.publication.confirmation_modal.alert')"
      />
    </template>
    <template #footer>
      <BaseButton
        color="inverted"
        @click="$emit('close')"
        v-test="'btn-publish-cancel'"
      >
        {{ $t('global.actions.cancel') }}
      </BaseButton>
      <BaseButton
        @click="$emit('submit')"
        v-test="'btn-publish-submit'"
      >
        {{ $t('feedback.publication.publish') }}
      </BaseButton>
    </template>
  </BaseModalSmall>
</template>

<script
  setup
  lang="ts"
>
defineEmits(['close', 'submit']);
</script>
